'use strict';

import _ from 'lodash';
import Vue from 'vue';
import uuid from 'node-uuid';
import toastr from 'toastr';
import OSS from 'ali-oss'

function getDomain() {
  let hostname = window.location.hostname;
  let lastDotIndex = hostname.lastIndexOf('.');
  if (lastDotIndex < 0 || !_.isNaN(parseInt(hostname.substring(lastDotIndex + 1)))) {
    return;
  }
  return hostname.substring(hostname.lastIndexOf('.', lastDotIndex - 1) + 1);
}

function fullClone(object) {
  if (_.isUndefined(object) || _.isNull(object) || _.isNaN(object)) {
    return object;
  }
  return JSON.parse(JSON.stringify(object));
}

function isMobile() {
  return window.innerWidth < 768;
}

function isDesktop() {
  return window.innerWidth >= 768;
}

function isWechat() {
  return window.navigator.userAgent && window.navigator.userAgent.match(/MicroMessenger/i);
}

function delay(duration) {
  return new Promise(resolve => {
    setTimeout(resolve, duration);
  });
}

const events = new Vue({});
const eventTypes = {
  CONFIRM: 'confirm'
};

function confirm(text, handler) {
  return new Promise(resolve => {
    events.$emit(eventTypes.CONFIRM, {text, handler, resolve});
  });
}

function showToast(type, message, title, options) {
  if (arguments.length < 4 && _.isObject(title)) {
    options = title;
    title = null;
  }
  options = _.extend({
    'closeButton': false,
    'debug': false,
    'newestOnTop': false,
    'progressBar': false,
    'positionClass': 'toast-top-center',
    'preventDuplicates': true,
    'onclick': null,
    'showDuration': '300',
    'hideDuration': '1000',
    'timeOut': '5000',
    'extendedTimeOut': '3000',
    'showEasing': 'swing',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
  }, options || {});
  toastr[type](message, title, options);
}

const toast = {
  success(message, title, options) {
    showToast('success', message, title, options);
  },
  info(message, title, options) {
    showToast('info', message, title, options);
  },
  warning(message, title, options) {
    showToast('warning', message, title, options);
  },
  error(message, title, options) {
    showToast('error', message, title, options);
  },
  clear() {
    toastr.clear();
  }
};

function handleGeneralError(e) {
  console.error(e);
  if (e.status && e.status === 403) {
    toast.error('全く許可しません！');
  } else {
    toast.error('サーバーに接続できません！');
  }
}

function formatIntoCSVRow(title, item) {
  let cells = [];
  if (item) {
    for (let key of _.keys(title)) {
      cells.push(item[key]);
    }
  } else {
    for (let key of _.keys(title)) {
      cells.push(title[key]);
    }
  }
  return cells.join(',') + '\n';
}

let blockerCounter = 0;

function showBlocker() {
  if (blockerCounter === 0) {
    $('.layout-body > .page-blocker').show();
  }
  blockerCounter ++;
}

function hideBlocker() {
  blockerCounter --;
  if (blockerCounter === 0) {
    $('.layout-body > .page-blocker').hide();
  }
}

function hideOnClickOutside(element, handler) {
  const outsideClickListener = event => {
    if (!element.contains(event.target)) { // or use: event.target.closest(selector) === null
      if (isVisible(element)) {
        removeClickListener();
        handler();
      }
    }
  };

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener);
  };

  document.addEventListener('click', outsideClickListener);
}

const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

function upload(url, data, file, onProgress) {
  let formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key])
  }
  formData.append('upload', file);
  return Promise.resolve($.ajax({
    xhr: () => {
      let xhr = new window.XMLHttpRequest();
      xhr.upload.addEventListener('progress', evt => {
        if (evt.lengthComputable) {
          let percentComplete = evt.loaded / evt.total;
          percentComplete = parseInt(percentComplete * 100);
          //console.log(percentComplete);
          if (onProgress) {
            onProgress(percentComplete);
          }
        }
      }, false);
      return xhr;
    },
    type: 'POST',
    url,
    cache: false,
    contentType: false,
    processData: false,
    data: formData
  }));
}

async function uploadFileToOSS(prefix, file, onProgress) {
  let extension = file.name.substring(file.name.lastIndexOf('.') + 1) || '';
  let name = extension ? file.name.substring(0, file.name.length - extension.length - 1) : file.name;
  let path = (prefix || '') + uuid.v4() + '/' + normalizeFileName(name) + '.' + extension;
  let response = await Vue.http.get('/api/oss');
  let config = response.body;
  let store = new OSS.Wrapper(config);
  response = await store.multipartUpload(path, file, {
    progress: function (p) {
      return function (done) {
        let progress = p * 100;
        //console.log(`Progress ${progress}`);
        onProgress(progress);
        done();
      };
    }
  });
  //console.log(response);
  let url = `http://${config.bucket}.${config.region}.aliyuncs.com/${path}`;
  //console.log(url);
  return url;
}

function normalizeFileName(name) {
  let regex = /[\w]|[^\x00-\x7F]|\./g;
  let array;
  let lastIndex = 0;
  let result = '';
  while ((array = regex.exec(name)) !== null) {
    let match = array[0];
    result += getCharacterReplacer(regex.lastIndex - lastIndex - match.length);
    result += match;
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < name.length) {
    result += getCharacterReplacer(name.length - lastIndex);
  }
  return result;
}

function getCharacterReplacer(count) {
  let result = '';
  for (let i = 0; i < count; i++) {
    result += '_';
  }
  return result;
}

const utils = {
  formatIntoCSVRow,
  getDomain,
  fullClone,
  isMobile,
  isDesktop,
  isWechat,
  delay,
  events,
  eventTypes,
  confirm,
  toast,
  handleGeneralError,
  showBlocker,
  hideBlocker,
  hideOnClickOutside,
  upload,
  uploadFileToOSS,
};

export default utils;


// WEBPACK FOOTER //
// ./client/app/scripts/utils.js